<div class="d-flex flex-column alig-items-center">
  <div class="login-form mx-auto">
    <h3 class="text-center">{{'message.setup2faRequired' | translate}}:</h3>
    <p class="text-center">{{'text.setup2faRequiredParagraph' | translate}}</p>
    <ng-container [ngSwitch]="type">
      <div *ngSwitchCase="I2faType.SMS">
        <app-set-2fa-sms
          [token]="token"
          [blockButtons]="true"
          (onSubmit)="handleSubmit($event)"
          (onCancel)="handleCancel()"
        ></app-set-2fa-sms>
      </div>
    </ng-container>
  </div>
</div>
